import gql from 'graphql-tag';
import { Query, Mutation } from 'core/index';

const SPACE_SUBSCRIPTION_STATUS = gql`
  fragment spaceSubscriptionStatus on Space {
    id
    whichTypes
    trialPeriodEnd
    hasPaidSubscription
    hasProSubscription
    hasBillingPermissions
    remainingSharedFiles
    spaceType
    subscriptionType
    content {
      id
      slug
    }
  }
`;

export const LOCAL_PROFILE_FIELDS = gql`
  ${SPACE_SUBSCRIPTION_STATUS}
  fragment localProfileFields on Profile {
    id
    user {
      id
      username
      emailStatus
    }
    profileConfirmed
    bio
    username
    invitesLeft
    locale
    fullName
    email
    intent {
      id
      name
    }
    userType {
      id
      name
    }
    avatar {
      id
      path
      url
    }
    imageFallbackChar
    preferredName
    inSpace {
      ...spaceSubscriptionStatus
    }
    content {
      id
      slug
      whitelabel
    }
  }
`;

export const SIGN_IN_MUTATION = gql`
  ${LOCAL_PROFILE_FIELDS}
  mutation Login($signInInput: SignInInput) {
    signInResult(signInData: $signInInput)
      @connection(key: "signInResult", filter: [""]) {
      result
      profile {
        ...localProfileFields
      }
      token
      refreshToken
    }
  }
`;

export class SignInMutation extends Mutation {
  static conf = {
    GQL: SIGN_IN_MUTATION,
    inputName: 'signInInput',
    resultPath: 'signInResult',
  };
}

export const WHOAMI = gql`
  ${LOCAL_PROFILE_FIELDS}
  query WhoAmI {
    loggedInUser {
      id
      profile {
        ...localProfileFields
        user {
          email
        }
        management
      }
      isStaff
      flagsJSON: flags
    }
  }
`;

export class WhoAmIQuery extends Query {
  static conf = {
    GQL: WHOAMI,
    resultPath: 'loggedInUser',
  };
}

const REQUEST_RESET_PASSWORD_MUTATION = gql`
  mutation RequestResetPassword($usernameOrEmail: String) {
    requestResetPassword(usernameOrEmail: $usernameOrEmail) {
      result
    }
  }
`;
export class RequestResetPasswordMutation extends Mutation {
  static conf = {
    GQL: REQUEST_RESET_PASSWORD_MUTATION,
    inputName: 'usernameOrEmail',
    resultPath: 'requestResetPassword',
  };
}

const NEW_PASSWORD_MUTATION = gql`
  mutation NewPassword($newPasswordInput: NewPasswordInput) {
    newPassword(newPasswordInput: $newPasswordInput)
      @connection(key: "newPassword", filter: [""]) {
      result
    }
  }
`;

export class NewPassWordMutation extends Mutation {
  static conf = {
    GQL: NEW_PASSWORD_MUTATION,
    inputName: 'newPasswordInput',
    resultPath: 'newPassword',
  };
}
